import React from "react"

export default function LoginFooter() {
  return (
    <div className="vt-login-footer">
      <p>
        All rights reserved &copy;{" "}
        <a href="https://vesatogo.com/" target="__blank">
          Vesatogo Innovations.
        </a>{" "}
        {new Date().getFullYear()}{" "}
      </p>
    </div>
  )
}
